import { ANALYTICS_CONFIG } from './config'

// Same queue-until-ready need as page views; kept separate since events don't
// carry a page-view's digitalData.page update.
const eventQueue: string[] = []
let queueFlushTimer: ReturnType<typeof setInterval> | null = null

const flushQueueWhenReady = (): void => {
  if (queueFlushTimer) return

  const startTime = Date.now()
  queueFlushTimer = setInterval(() => {
    if (globalThis.window?._satellite?.track) {
      while (eventQueue.length > 0) {
        const queuedEvent = eventQueue.shift()
        if (queuedEvent) globalThis.window._satellite.track(queuedEvent)
      }
      clearInterval(queueFlushTimer!)
      queueFlushTimer = null
    } else if (Date.now() - startTime > 30000) {
      eventQueue.length = 0
      clearInterval(queueFlushTimer!)
      queueFlushTimer = null
    }
  }, 500)
}

const fireEvent = (eventName: string, eventData?: Record<string, any>): void => {
  try {
    if (globalThis.window?.digitalData && eventData) {
      globalThis.window.digitalData.event = {
        ...globalThis.window.digitalData.event,
        ...eventData,
      }
    }

    if (globalThis.window?._satellite?.track) {
      globalThis.window._satellite.track(eventName)
    } else {
      eventQueue.push(eventName)
      flushQueueWhenReady()
    }
  } catch (error) {
    console.error(`CJA: error tracking event ${eventName}`, error)
  }
}

/** Tracks a time-off request form submission. */
export const trackFormSubmit = (step?: string, data?: Record<string, any>): void => {
  fireEvent(ANALYTICS_CONFIG.EVENTS.FORM_SUBMIT, {
    action: 'Form Submission',
    step,
    timestamp: new Date().toISOString(),
    ...data,
  })
}

/** Tracks a time-off request draft save. */
export const trackFormSave = (step?: string, data?: Record<string, any>): void => {
  fireEvent(ANALYTICS_CONFIG.EVENTS.FORM_SAVE, {
    action: 'Form Save',
    step,
    timestamp: new Date().toISOString(),
    ...data,
  })
}

/** Tracks a form validation error. */
export const trackFormError = (errorFields: string[], step?: string): void => {
  fireEvent(ANALYTICS_CONFIG.EVENTS.FORM_ERROR, {
    action: 'Form Validation Error',
    step,
    errorFields,
    errorCount: errorFields.length,
    timestamp: new Date().toISOString(),
  })
}

/** Tracks a button click. */
export const trackButtonClick = (buttonName: string, location?: string): void => {
  fireEvent(ANALYTICS_CONFIG.EVENTS.BUTTON_CLICK, {
    buttonClick: {
      buttonName,
      buttonLocation: location || 'unknown',
    },
  })
}
